import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LandingPage from './components/LandingPage';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import UserProfile from './components/UserProfile';
import AdminDashboard from './components/AdminDashboard';
import DebugDashboard from './components/DebugDashboard';
import './App.css';

// Protected Route Component
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className='flex items-center justify-center min-h-screen px-4'>
        <div className='text-center space-y-4'>
          <div className='text-lg font-medium'>Loading...</div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to='/login' replace />;
  }

  // if (user.status !== 'approved') {
  //   return (
  //     <div className='flex items-center justify-center min-h-screen px-4'>
  //       <div className='text-center space-y-4 p-6 sm:p-8 max-w-md'>
  //         <h2 className='text-xl sm:text-2xl font-bold'>
  //           Account Pending Approval
  //         </h2>
  //         <p className='text-gray-600 text-sm sm:text-base'>
  //           Your account is pending approval. Please wait for an administrator
  //           to approve your account.
  //         </p>
  //       </div>
  //     </div>
  //   );
  // }

  return <>{children}</>;
};

// Admin Route Component
const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className='flex items-center justify-center min-h-screen px-4'>
        <div className='text-center space-y-4'>
          <div className='text-lg font-medium'>Loading...</div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to='/login' replace />;
  }

  // if (user.status !== 'approved') {
  //   return (
  //     <div className='flex items-center justify-center min-h-screen px-4'>
  //       <div className='text-center space-y-4 p-6 sm:p-8 max-w-md'>
  //         <h2 className='text-xl sm:text-2xl font-bold'>
  //           Account Pending Approval
  //         </h2>
  //         <p className='text-gray-600 text-sm sm:text-base'>
  //           Your account is pending approval. Please wait for an administrator
  //           to approve your account.
  //         </p>
  //       </div>
  //     </div>
  //   );
  // }

  if (user.role !== 'admin' && user.role !== 'super-admin') {
    return <Navigate to='/' replace />;
  }

  return <>{children}</>;
};

// Home Route Component
const HomeRoute: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className='flex items-center justify-center min-h-screen px-4'>
        <div className='text-center space-y-4'>
          <div className='text-lg font-medium'>Loading...</div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to='/login' replace />;
  }

  // If user is admin or super-admin, redirect to admin dashboard
  if (user.role === 'admin' || user.role === 'super-admin') {
    return <Navigate to='/admin' replace />;
  }

  // For regular users, redirect to profile (which serves as their dashboard)
  return <Navigate to='/profile' replace />;
};

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AuthProvider>
        <Routes>
          <Route path='/' element={<HomeRoute />} />
          <Route path='/landing' element={<LandingPage />} />
          <Route path='/login' element={<Login />} />
          <Route path='/register' element={<Register />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/reset-password' element={<ResetPassword />} />
          <Route
            path='/profile'
            element={
              <ProtectedRoute>
                <UserProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path='/admin/*'
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            }
          />
          <Route
            path='/admin-debug'
            element={
              <AdminRoute>
                <DebugDashboard />
              </AdminRoute>
            }
          />
          <Route path='*' element={<Navigate to='/' replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
